<template>
  <div class="news-organization">
    <div class="container-fluid">
      <b-form class="organization-search-form" @submit.prevent="onSubmit">
        <b-form-group>
          <fa-icon icon="search" class="input-icon"></fa-icon>
          <img
              class="input-clear"
              src="../assets/img/common/input-clear.png"
              alt="Search Clear"
              @click="searchClear">
          <b-form-input
              v-model="organizesFilter.name"
              class="form-control-custom"
              placeholder="ค้นหาองค์กร">
          </b-form-input>
        </b-form-group>
      </b-form>
    </div>

    <template v-for="(organize, index) in organizes">
      <div
        :key="index"
        class="organization">
        <div class="image-wrapper">

            <div  v-if="organize.organize_logo"
              class="logo-image-cover">
              <img class="logo-image" :src="organize.organize_logo">
            </div>


          <div v-if="!organize.organize_logo"
               class="image"
               :style="{ backgroundImage: `url('/static/img/common/organization-placeholder.jpg')` }"></div>

        </div>
        <div
            :class="{ followed: organize.follow }"
            class="title"
            @click="$router.push(`/news/organization/${organize.id}`)">
          <span>{{ organize.name }}</span>
        </div>
        <div class="action">
          <template v-if="!organize.follow">
            <button
              class="btn btn-news btn-sm"
              @click="toggleFollow(organize.id)">ติดตาม</button>
          </template>
          <template v-if="organize.follow">
            <button
              class="btn btn-dark btn-sm"
              @click="toggleFollow(organize.id)">ติดตามแล้ว</button>
          </template>
        </div>
      </div>
    </template>

    <footer>
      <button
        class="btn btn-news btn-round shadow-bottom follow-all"
        @click="followAll">
        ติดตามทั้งหมด
      </button>

      <img
          src="../assets/img/common/onde.svg"
          class="logo"
          alt="Footer logo">
    </footer>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import { EventBus } from '../utils/EventBus.js'

  export default {
    name: 'news-organization',

    props: {
      districtId: {
        type: String,
        default: null
      }
    },

    data () {
      return {
        page: 1
      }
    },

    computed: {
      // Map Vuex state.
      ...mapState({
        organizes: state => {
          return state.Organize.organizes
        },
        organizesFilter: state => {
          return state.Organize.organizesFilter
        }
      })
    },

    created () {
      // Listen to scroll to end event.
      EventBus.$on('scroll-to-end', this.appendOrganizes)

      return this.$store.dispatch('Organize/setOrganizeFilter', {
        ...this.organizesFilter,
        districtId: this.districtId
      })
        .then(() => this.$store.dispatch('Organize/getOrganizes'))
    },

    destroyed () {
      EventBus.$off('scroll-to-end', this.appendOrganizes)
    },

    methods: {
      appendOrganizes () {
        this.page++
        return this.$store.dispatch('Organize/getOrganizes', this.page)
      },
      onSubmit () {
        this.page = 1
        return this.$store.dispatch('Organize/getOrganizes')
      },
      searchClear () {
        this.page = 1
        this.$store.dispatch('Organize/setOrganizeFilter', {
          ...this.organizesFilter,
          name: ''
        })
          .then(() => this.$store.dispatch('Organize/getOrganizes'))
      },
      toggleFollow (organizeId) {
        return this.$store.dispatch(`Organize/followOrganization`, organizeId)
      },
      followAll () {
        let followPromises = []
        this.organizes.forEach(organize => {
          if (!organize.follow) {
            followPromises = [
              ...followPromises,
              this.$store.dispatch(`Organize/followOrganization`, organize.id)
            ]
          }
        })
        Promise.all(followPromises)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .logo-image{
    height: 100%;
    display:block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    border-radius: 50%;
  }

  .logo-image-cover{
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    border-radius: 50%;
  }

  .news-organization {
    padding: 20px 0 0;
    .organization {
      @extend .d-flex;
      padding: 10px 20px;
      &:not(:last-child) {
        border-bottom: 1px solid $border-color;
      }
      .image-wrapper {
        border: 2px solid #DADADA;
        box-sizing: border-box;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
        border-radius: 50%;
        padding: 2px;
        width: 60px;
        height: 60px;
        flex: none;
        .image {
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          height: 100%;
          border-radius: 50%;
        }
      }
      .title {
        @extend .flex-grow-1;
        @extend .d-flex;
        padding: 0 20px;
        span {
          font-size: 12px;
          color: $text-color;
          margin: auto 0;
        }
        &.followed {
          span {
            color: $news-color;
          }
        }
      }
      .action {
        @extend .d-flex;
        button {
          margin: auto;
          width: 85px;
        }
      }
    }
    footer {
      @extend .position-relative;
      @extend .text-center;
      padding: 25px 0 35px;
      .follow-all {
        padding-left: 40px;
        padding-right: 40px;
      }
      .logo {
        @extend .position-absolute;
        right: 5px;
        bottom: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsOrganization.component.vue